import '../../../app.es6';
import angular from 'angular';

const COMPONENT_NAME = 'dialogInterimPassword';
class DialogInterimPassword {
  /* @ngInject */
  constructor (
    $rootScope, $scope, $sessionStorage, $location,
    commonApiFactory, commonFactory, Const
  ) {
    this.Const = Const;
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$sessionStorage = $sessionStorage;
    this.$location = $location;
    this.commonApiFactory = commonApiFactory;
    this.commonFactory = commonFactory;
    DialogInterimPassword.$inject = ['$rootScope', '$scope',
                                     '$sessionStorage', '$location',
                                     'commonApiFactory', 'commonFactory',
                                     'Const'];
  }

  // TODO: password reset
  resetPassword () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }
    console.log(this.$rootScope.password + ' にresetします。');
    let url = window.location.href;
    let fromScreen =
      (~url.indexOf('/admin/school')) ? this.Const.ADMIN_SCREEN_TYPE.schoolList
      : (~url.indexOf('/admin/coach')) ? this.Const.ADMIN_SCREEN_TYPE.coachList
      : (~url.indexOf('/admin/member')) ? this.Const.ADMIN_SCREEN_TYPE.memberList
      : this.Const.ADMIN_SCREEN_TYPE.unknown;

    // 遷移元画面によって関数を呼び分ける
    switch (fromScreen) {
      case this.Const.ADMIN_SCREEN_TYPE.schoolList:
        this.postCompaniesMeSchoolsSchoolIdAdminPasswordReset();
        break;
      case this.Const.ADMIN_SCREEN_TYPE.coachList:
        this.postSchoolsSchoolIdStaffsStaffIdPasswordReset();
        break;
      case this.Const.ADMIN_SCREEN_TYPE.memberList:
        this.postSchoolsSchoolIdMembersMemberIdPasswordReset();
        break;
      default:
        // unknown...
    }
  }

  // company Adminがschool Adminの仮パスワードを発行するためのAPI
  postCompaniesMeSchoolsSchoolIdAdminPasswordReset () {
    let params = { schoolId: this.$rootScope.targetId };
    let bodies = { temporaryPassword: this.$rootScope.password };
    this.commonApiFactory.postAdminCompaniesMeSchoolsSchoolIdAdminPasswordReset(params, bodies)
    .then((result) => {
      // OK
    })
    .catch((error) => {
      console.log('error : ', error);
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_UNEXPECTED_ERROR, 5000, false);
    });
  }

  // School Adminがコーチの仮パスワードを発行するためのAPI
  postSchoolsSchoolIdStaffsStaffIdPasswordReset () {
    let params = { staffId: this.$rootScope.targetId, schoolId: this.$sessionStorage[this.Const.SSAPP_SCHOOL_ID] };
    let bodies = { temporaryPassword: this.$rootScope.password };
    this.commonApiFactory.postAdminSchoolsSchoolIdStaffsStaffIdPasswordReset(params, bodies)
    .then((result) => {
      // OK
    })
    .catch((error) => {
      console.log('error : ', error);
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_UNEXPECTED_ERROR, 5000, false);
    });
  }

  // School Adminが生徒の仮パスワードを発行するためのAPI
  postSchoolsSchoolIdMembersMemberIdPasswordReset () {
    let params = { memberId: this.$rootScope.targetId, schoolId: this.$sessionStorage[this.Const.SSAPP_SCHOOL_ID] };
    let bodies = { temporaryPassword: this.$rootScope.password };
    this.commonApiFactory.postAdminSchoolsSchoolIdMembersMemberIdPasswordReset(params, bodies)
    .then((result) => {
      // OK
    })
    .catch((error) => {
      console.log('error : ', error);
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_UNEXPECTED_ERROR, 5000, false);
    });
  }
}

angular.module('myApp').component(COMPONENT_NAME,
  {
    bindings: {
      name: '@' + COMPONENT_NAME
    },
    controller: DialogInterimPassword,
    templateUrl: 'app/components/dialog/interim-password/dialog-interim-password.template.html'
  }
);



// WEBPACK FOOTER //
// ./app/components/dialog/interim-password/dialog-interim-password-controller.es6